import Vue from 'vue'
import ProgressSpinner from '../components/ProgressSpinner'

Vue.component('app-navigation-drawer', () => ({
    component: import('./NavigationDrawer'),
loading: ProgressSpinner
}))
Vue.component('app-toolbar', () => ({
    component: import('./Toolbar'),
loading: ProgressSpinner
}))
Vue.component('app-footer', () => ({
    component: import('./footer'),
loading: ProgressSpinner
}))
Vue.component('app-content', () => ({
    component: import('./Content'),
    loading: ProgressSpinner
}))


// WEBPACK FOOTER //
// ./resources/js/views/index.js